import styles from "../App.module.css";

export const pageBasicCss = `${styles.minHeightMaxWidth} ${styles.centerVertically} ${styles.centerHorizontally} ${styles.flexVertically}`;
export const centerThings = `${styles.centerHorizontally} ${styles.centerVertically}`;
export const arrangeVertically = `${styles.centerVertically} ${styles.centerHorizontally} ${styles.flexVertically} ${styles.gap}`;
